import { describeFields } from '../common/fields';
import { VideoCategorySchema, VideoCategoryTopicSchema } from './schemas';

export const VIDEO_CATEGORY_FIELDS = describeFields(VideoCategorySchema, {
  subject: {},
  category: {},
  label: {},
  shortLabel: {},
  topics: {},
});

export const VIDEO_CATEGORY_TOPIC_FIELDS = describeFields(VideoCategoryTopicSchema, {
  key: {},
  label: {},
  shortLabel: {},
  resources: {},
  videos: {},
});
